<mtna-section-header [icon]="data.icon" [title]="data.title" [description]="data.description"></mtna-section-header>
<mat-dialog-content [style.height]="data.contentHeight">
  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        <span [matBadge]="_selectedBundles?.length | rdsNumToString" [matBadgeHidden]="!_selectedBundles?.length" matBadgeOverlap="false"
          >Bundles</span
        >
      </ng-template>
      <ng-template matTabContent>
        <rds-c-bundle-selection-list
          [bundles]="data.bundles"
          [color]="data.color"
          [selected]="_selectedBundles"
          (selectionChange)="handleBundleSelectionChange($event)"
        ></rds-c-bundle-selection-list>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span [matBadge]="_selectedFormats.length | rdsNumToString" [matBadgeHidden]="!_selectedFormats.length" matBadgeOverlap="false"
          >All Formats</span
        >
      </ng-template>
      <ng-template matTabContent>
        <rds-c-format-selection-list
          [options]="data.options"
          [selected]="_selectedFormats"
          (add)="handleFormatSelectionAdd($event)"
          (remove)="handleFormatSelectionRemove($event)"
        ></rds-c-format-selection-list>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="data.documentOptionSets && data.documentOptionSets.length > 0">
      <ng-template mat-tab-label>
        <span
          [matBadge]="_selectedDocumentOptionSets.length | rdsNumToString"
          [matBadgeHidden]="!_selectedDocumentOptionSets.length"
          matBadgeOverlap="false"
          >Documents</span
        >
      </ng-template>
      <ng-template matTabContent>
        <rds-c-document-selection-list
          [documentOptionSets]="data.documentOptionSets"
          [selected]="_selectedDocumentOptionSets"
          (selectionChange)="handleDocumentSelectionChange($event)"
        ></rds-c-document-selection-list>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px">
  <button mat-button mat-dialog-close>CANCEL</button>
  <button
    mat-raised-button
    [color]="data.color"
    [disabled]="!(_selectedBundles.length + _selectedFormats.length + _selectedDocumentOptionSets.length)"
    [mat-dialog-close]="selectedBundlesAndFormats"
  >
    SELECT [{{ _selectedBundles.length + _selectedFormats.length + _selectedDocumentOptionSets.length }}]
  </button>
</mat-dialog-actions>
